
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.003","height":"19.724"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Сгруппировать 28785"}},[_c('g',{attrs:{"data-name":"Сгруппировать 28784"}},[_c('path',{attrs:{"data-name":"Контур 34841","d":"M21.508 15.771l-8.3-14.37a2.552 2.552 0 00-4.421 0l-8.3 14.37a2.552 2.552 0 002.21 3.828h16.601a2.552 2.552 0 002.21-3.828zm-1.1 1.917a1.268 1.268 0 01-1.109.64H2.705a1.281 1.281 0 01-1.109-1.918l8.3-14.37a1.281 1.281 0 012.218 0l8.3 14.37a1.268 1.268 0 01-.007 1.278z","fill":"#fff","stroke":"#fff","stroke-width":".25"}})])]),_c('g',{attrs:{"data-name":"Сгруппировать 28787"}},[_c('g',{attrs:{"data-name":"Сгруппировать 28786"}},[_c('path',{attrs:{"data-name":"Прямоугольник 5257","fill":"#fff","stroke":"#fff","stroke-width":".25","d":"M10.366 6.471h1.272v6.358h-1.272z"}})])]),_c('g',{attrs:{"data-name":"Сгруппировать 28789"}},[_c('g',{attrs:{"data-name":"Сгруппировать 28788"}},[_c('path',{attrs:{"data-name":"Контур 34842","d":"M11.002 14.101a.848.848 0 10.848.848.849.849 0 00-.848-.848z","fill":"#fff","stroke":"#fff","stroke-width":".25"}})])])])
          )
        }
      }
    